/* eslint-disable */
import InfinityLoader from '@/components/common/infinityLoader'
import SelectProfession from '@/components/common/select/SelectUserProfession'
import SelectUserSpecialty from '@/components/common/select/SelectUserSpecialty'
import SelectCity from '@/components/common/SelectCity'
import SelectCountry from '@/components/common/SelectCountry'
import SelectQualification from '@/components/common/select/SelectQualification'
import { PersonalInfoType } from '@/components/dashboard/members/profile/types'
import { handleCV } from '@/util/imageUpload'
import {
  Button,
  InputWrapper,
  Loader,
  LoadingOverlay,
  Select,
  TextInput,
  NumberInput,
  Title,
  Radio,
  RadioGroup,
  Switch,
} from '@mantine/core'
import classNames from 'classnames'
import { parseInt } from 'lodash'
import useTranslation from 'next-translate/useTranslation'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import Divider from '../components/Divider'
import containsSpecialChars from '@/util/specialchar'
import useProfileBasicInfoForm from '@/hooks/client/Profile/useProfileBasicInfoForm'
import ProfileCVForm from './ProfileCvForm'
import { useEffect, useState } from 'react'
import SelectRank from '@/components/common/select/SelectRank'

type UserInfo = PersonalInfoType & {
  scfhsOption?: string
}

const ProfileBasicInfoForm = ({
  profile: profileUser,
  refetch,
  cvData,
  setShowCv,
  showCv,
}: {
  profile: PersonalInfoType
  refetch?: () => void
  cvData?: any
  setShowCv?: (value: string) => void
  showCv?: string
}) => {
  let profile: UserInfo = profileUser
  profile.scfhsOption =
    profileUser.scfhs && profileUser.scfhs?.length > 0 ? 'yes' : ''
  const { t, lang } = useTranslation('client')

  const {
    openAvatar,
    handleUpdate,
    form,
    uploadImageLoading,
    back,
    loading,
    phoneNumberRef,
    uploadCVLoading,
    isTrainer,
    yesNoRef,
    isArabic,
    setUploadCVLoading,
    isBecomeTrainer,
  } = useProfileBasicInfoForm({
    profile: profileUser,
    refetch,
  })

  const handleQualificationChange = (value: string) => {
    form.setFieldValue('Qualification', value)
    form.setFieldValue('trainerCv', {
      ...form.values.trainerCv,
      qualification: value,
    })
  }

  const handleRankChange = (value: string) => {
    form.setFieldValue('trainerCv', {
      ...form.values.trainerCv,
      rank: value,
    })
  }
  return (
    <form
      onSubmit={form.onSubmit(handleUpdate)}
      className="divide-y divide-gray-200 lg:col-span-9 relative"
    >
      <LoadingOverlay
        loader={<InfinityLoader variant="lg" />}
        visible={loading}
      />
      <div className="py-6 px-4 sm:p-6 lg:pb-8 grid grid-cols-12 gap-2">
        <div className=" col-span-12">
          <Title order={4}> {t('profile')}</Title>
        </div>
        <div className="mt-6 flex flex-col lg:flex-row col-span-12">
          <div className="flex-grow space-y-6">
            <div className="col-span-12 sm:col-span-6">
              <TextInput
                required
                error={
                  /[a-zA-Z]/.test(form.values.nameAr)
                    ? t('invalidArabicName')
                    : false
                }
                styles={{
                  input: {
                    direction: isArabic
                      ? ('ltr!important' as 'ltr')
                      : ('rtl!important' as 'rtl'),
                    textAlign: isArabic
                      ? ('left!important' as 'left')
                      : ('right!important' as 'right'),
                  },
                }}
                {...form.getInputProps('nameAr')}
                label={t('arabicFullName')}
              />
            </div>

            <div className="col-span-12 sm:col-span-6">
              <TextInput
                required
                error={
                  /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(
                    form.values.name,
                  )
                    ? t('invalidEnglishName')
                    : false
                }
                styles={{
                  input: {
                    direction: !isArabic
                      ? ('ltr!important' as 'ltr')
                      : ('rtl!important' as 'rtl'),
                    textAlign: !isArabic
                      ? ('left!important' as 'left')
                      : ('right!important' as 'right'),
                  },
                }}
                {...form.getInputProps('name')}
                label={t('englishFullName')}
              />
            </div>
          </div>

          <div
            className={classNames(
              'mt-6 flex-grow lg:mt-0 lg:flex-grow-0 lg:flex-shrink-0',
              isArabic ? 'lg:mr-6' : 'lg:ml-6',
            )}
          >
            <p
              className="text-sm font-medium text-gray-700 text-center "
              aria-hidden="true"
            >
              {t('profilePhoto')}
            </p>
            <div className="mt-1 lg:hidden">
              <div className="flex items-center">
                <div
                  className="flex-shrink-0 inline-block rounded-full overflow-hidden h-12 w-12"
                  aria-hidden="true"
                >
                  {uploadImageLoading ? (
                    <div className="h-full w-full flex justify-center items-center">
                      <Loader />
                    </div>
                  ) : (
                    <img
                      className="rounded-full h-full w-full"
                      src={form.values?.image || '-'}
                      alt=""
                    />
                  )}
                </div>
                <div className="flex flex-row gap-2 mx-5 rounded-md shadow-sm">
                  <div className="group relative border border-gray-300 rounded-md py-2 px-3 flex items-center justify-center hover:bg-gray-50 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary">
                    <label
                      htmlFor="mobile-user-photo"
                      className="relative text-sm leading-4 font-medium text-gray-700 pointer-events-none"
                    >
                      <span>{t('change')}</span>
                      <span className="sr-only"> user photo</span>
                    </label>
                    <input
                      onChange={e => {
                        if (e.target.files) {
                          openAvatar(e.target.files[0])
                        }
                      }}
                      id="mobile-user-photo"
                      name="user-photo"
                      type="file"
                      className="absolute w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md"
                    />
                  </div>
                  {/* 
                  <div
                    onClick={e => form.setFieldValue('image', '')}
                    className="group relative border border-gray-300 rounded-md py-2 px-3 flex items-center justify-center hover:bg-gray-50 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary"
                  >
                    <label
                      htmlFor="mobile-user-photo"
                      className="relative text-sm leading-4 font-medium text-gray-700 pointer-events-none"
                    >
                      <span>{t('remove')}</span>
                    </label>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2 justify-center items-center">
              <div className="hidden relative rounded-full overflow-hidden lg:block">
                {uploadImageLoading ? (
                  <div className="w-40 h-40 flex justify-center items-center">
                    <Loader size="xl" />
                  </div>
                ) : (
                  <img
                    className="relative rounded-full w-40 h-40"
                    src={form.values?.image || '-'}
                    alt=""
                  />
                )}

                <label
                  htmlFor="desktop-user-photo"
                  className="absolute inset-0 w-full h-full bg-black bg-opacity-75 flex items-center justify-center text-sm font-medium text-white opacity-0 hover:opacity-100 focus-within:opacity-100"
                >
                  <span>{t('change')}</span>
                  <span className="sr-only"> user photo</span>
                  <input
                    onChange={e => {
                      if (e.target.files) {
                        openAvatar(e.target.files[0])
                      }
                    }}
                    type="file"
                    id="desktop-user-photo"
                    name="user-photo"
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md"
                  />
                </label>
              </div>
              {/*               <div className="hidden lg:block">
                <BlurredButton onClick={e => form.setFieldValue('image', '')}>
                  {t('remove')}
                </BlurredButton>
              </div> */}
            </div>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-6 ">
          <TextInput
            required
            disabled
            label={t('email')}
            {...form.getInputProps('email')}
          />
        </div>
        <div className="col-span-12 lg:col-span-6 ">
          <InputWrapper label={t('mobileNumber')} required>
            <div dir="ltr">
              <PhoneInput
                required
                defaultCountry="SA"
                placeholder="Enter phone number"
                value={form.getInputProps('mobileNumber').value}
                onChange={form.getInputProps('mobileNumber').onChange}
                ref={phoneNumberRef}
              />
            </div>
          </InputWrapper>
        </div>

        <div className="col-span-12 lg:col-span-6 ">
          <Select
            required
            data={[
              { label: t('male'), value: 'male' },
              { label: t('female'), value: 'female' },
            ]}
            label={t('gender')}
            {...form.getInputProps('gender')}
          />
        </div>
        <div className="col-span-12 lg:col-span-6 ">
          <SelectCountry
            required
            countryId={form.values.nationality}
            onSelect={e => {
              form.setFieldValue('nationality', e)
            }}
            label={t('nationality')}
          />
        </div>

        {/*   <div className="col-span-12 lg:col-span-6">
          <DatePicker
            required
            placeholder="Pick date"
            {...form.getInputProps('birthday')}
            label={t('birthday')}
          />
        </div> */}
        {isBecomeTrainer && (
          <div className="col-span-12 lg:col-span-6">
            <NumberInput
              hideControls
              required
              label={t('identity')}
              {...form.getInputProps('identityNo')}
            />
          </div>
        )}

        <div className="col-span-12 ">
          <div className="grid grid-cols-1 gap-2  lg:grid-cols-3 ">
            <SelectCity
              required
              cityId={parseInt(form.values.city)}
              onSelect={id => {
                form.setFieldValue('city', id)
              }}
            />
          </div>
        </div>

        <Divider />
        <div className="col-span-12 lg:col-span-6">
          <SelectProfession
            required
            inputProps={form.getInputProps('profession')}
          />
        </div>
        <div className="col-span-12 lg:col-span-6">
          <SelectUserSpecialty
            required
            inputProps={form.getInputProps('specialty')}
            professionId={parseInt(form.values.profession)}
          />
        </div>
        <div className="col-span-12 lg:col-span-6 ">
          <SelectQualification
            inputProps={{
              ...form.getInputProps('Qualification'),
              onChange: e => handleQualificationChange(e),
            }}
            // onChange={handleQualificationChange}
            required
          />
        </div>

        <div className="col-span-12 lg:col-span-6 ">
          <SelectRank
            inputProps={{
              onChange: e => handleRankChange(e),
              value: form.values.trainerCv?.rank,
            }}
            required
          />
        </div>

        <div className="col-span-12 mt-3" ref={yesNoRef}>
          <RadioGroup
            color="rgba(16, 222, 208, 1)"
            label={t('Havescfhs')}
            required
            {...form.getInputProps('scfhsOption')}
          >
            <Radio value="yes" label={t('yes')} />
            <Radio value="no" label={t('no')} />
          </RadioGroup>
        </div>
        {form.getInputProps('scfhsOption').value == 'yes' && (
          <div className="col-span-6">
            <TextInput
              label={t('scfhs')}
              error={
                containsSpecialChars(form.values.scfhs)
                  ? t('scfhsCharErr')
                  : false
              }
              value={form.values.scfhs}
              onChange={e => {
                let no = e.currentTarget.value.toUpperCase()
                form.setFieldValue('scfhs', no)
              }}
              required={form.values.scfhsOption == 'yes'}
            />
          </div>
        )}
        {/* <div className="col-span-12 lg:col-span-6">
          <DatePicker
            label={t('scfhsExp')}
            {...form.getInputProps('scfhsExp')}
          />
        </div> */}

        <Divider />

        <div className="col-span-12 lg:col-span-6">
          <TextInput label={t('twitter')} {...form.getInputProps('twitter')} />
        </div>
        <div className="col-span-12 lg:col-span-6">
          <TextInput
            label={t('linkedIn')}
            {...form.getInputProps('linkedIn')}
          />
        </div>
        {cvData && (
          <div className="p-4 col-span-12">
            <Title order={3}>Resume</Title>
            <RadioGroup
              className="mt-1"
              value={showCv}
              onChange={setShowCv}
              orientation="vertical"
              // label="Choose Resume Submission Method"
              description="Select how you'd like to submit your Resume: either create one directly within the app or upload an existing Resume file."
              required
              classNames={{
                description: 'text-[22px] font-bold',
                // radioWrapper: 'text-[22px] font-bold',
                // label: 'text-[14px] font-regular',
              }}
            >
              <Radio value="true" label="Upload your resume" />
              <Radio value="false" label="Create your resume" />
            </RadioGroup>
          </div>
        )}
      </div>

      {(isTrainer || (showCv === 'true' && cvData)) && (
        <div className="mt-4 py-4 px-4 flex justify-center sm:px-6 gap-2 flex-col items-center">
          <div className="mx-5 rounded-md shadow-sm">
            <div className="group relative border border-gray-300 rounded-md py-2 px-3 flex items-center justify-center hover:bg-gray-50 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary">
              <label
                htmlFor="mobile-user-photo"
                className="relative text-sm leading-4 font-medium text-gray-700 pointer-events-none"
              >
                <span>
                  {uploadCVLoading ? <Loader size="sm" /> : t('attachCv')}
                </span>
              </label>

              <input
                required={showCv === 'true' && cvData && !form.values.cv}
                onChange={e => {
                  if (e.target.files) {
                    const image = e.target.files[0]
                    if (image) {
                      setUploadCVLoading(true)
                      handleCV(image).then(({ originalname, path }) => {
                        form.setFieldValue(
                          'cv',
                          JSON.stringify({ path, originalname }),
                        )
                        setUploadCVLoading(false)
                      })
                    }
                  }
                }}
                id="mobile-user-photo"
                name="user-photo"
                type="file"
                className="absolute w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md"
              />
            </div>
          </div>
          <a href={JSON.parse(form.values.cv || '{}')?.path}>
            {uploadCVLoading ? (
              <Loader size="sm" />
            ) : form.values.cv ? (
              JSON.parse(form.values.cv || '{}')?.originalname
            ) : (
              ''
            )}
          </a>
        </div>
      )}
      {cvData && (
        <div className="mt-4 py-4 px-4 flex justify-center sm:px-6 gap-2">
          <button
            type="button"
            className="bg-white button-focus-ring"
            onClick={() => back()}
          >
            {t('cancel')}
          </button>
          <Button type="submit">{t('save')}</Button>
        </div>
      )}
      {/* {cvData && (
        <>
          <ProfileCVForm
            cv={cvData?.findProfile?.trainerCv as any}
            bankAccount={(cvData?.findProfile?.bankAccount as any) || {}}
            refetch={refetch}
            showCv={showCv}
          />
        </>
      )} */}
      {!cvData && (
        <div className="mt-4 py-4 px-4 flex justify-center sm:px-6 gap-2">
          <button
            type="button"
            className="bg-white button-focus-ring"
            onClick={() => back()}
          >
            {t('cancel')}
          </button>
          <Button type="submit">{t('save')}</Button>
        </div>
      )}
    </form>
  )
}

export default ProfileBasicInfoForm
